<template>
  <div class="about-main-content-component d-block d-lg-none overflow-hidden">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="mx-3 my-5">
            <h2>Bringing enjoyment and optimism through chocolates.</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="about-image"></div>
    <div class="container">
      <div class="row mt-5 px-3">
        <div class="col-12">
          <h3 class="story-intro top-margin-10">
            <strong class="uppercase">In the beginning, there was passion.</strong>
          </h3>

          <p class="mt-4 justify">
            <em>It all started in a small kitchen</em> that could barely fit two persons.
            It was in that small kitchen where our founders spent crazy long hours every night,
            tirelessly formulating and testing recipes to create their first chocolate product (much to the delight of their children!).
          </p>

          <p class="mt-4 justify">
            Without experience in chocolate-making or any kind of product development,
            it was a struggle at first. Some nights were great, but in some they felt like giving up.
            But it was passion that kept them going - a passion to make an exceptional and yet affordable chocolate products available to the masses.
            And that is how Valmarce Food Marketing Corporation was born. 
          </p>

          <p class="mt-4 justify">
            In 2005, Valmarce first introduced the chocolate tablea - intended for hot chocolate, champorado, and other chocolate applications, under the brand name, Dutché Chocolates.
          </p>

          <p class="mt-4 justify">
            From our humble beginnings of working countless hours in the small kitchen,
            our products are now available in leading supermarkets such as: 
            SM Supermarket, SM Department Stores, Hypermarket, Savemore, all Robinsons Supermarket, Metro Gaisano (Market), Rustan’s, 
            Shopwise, The Landmark, Waltermart, Puregold, and other local chain of supermarkets and select chocolate shops nationwide.
          </p>

          <p class="mt-4 justify">
            As to this day, we continue to formulate new products and find ways to make them readily available for you.
          </p>

          <h3 class="story-intro mt-5">
            <strong class="uppercase">WE ARE FAMILY</strong>
          </h3>

          <p class="mt-4 justify">
            More than just a company, we are a family - a family that works together and eats chocolates together. It’s what makes an enthusiastic and full bond.
          </p>

          <p class="mt-4 justify">
            <em>Since our humble beginnings</em> in 2005, we’ve created chocolate products that we’ve madly fallen in love with - that we’ll fight for,
            and eat all day, alone or together, with our bare hands, hungry or not, anywhere, and even after bedtime.
          </p>

          <p class="mt-4 justify">
            We use superlative ingredients with passion (while humming Celine Dion’s I Can’t Live Without You. 
            Yes, we listen to cheesy love songs while making/packing/delivering that chocolate you might be holding right now. 
            We figured cheesy love songs set the perfect mood).
          </p>

          <p class="mt-4 justify">
            Here at Valmarce we love what we do - especially the product-tasting part!
            We are nice and fun people with a serious mission to bring you exceptional products.
            And make you fall in love with them as much as we do.
            Each time you get a Dutché chocolate, you’re not only getting a product, but a TLC from us as well.
            So the next time you get a Dutché Chocolate Spread or a Dutché chocolate bar, imagine us giving you a big fat group hug!
          </p>
        </div>
      </div>
    </div>
    <div class="mb-5"></div>
  </div>
</template>

<script>
export default {
  name: "Main_Content"
};
</script>

<style lang="sass" scoped>
h2
  font-family: "Might Could"
  font-size: 2.5em

.about-image
  background-image: url('../../assets/images/about/about_img0.png')
  background-size: cover
  background-repeat: no-repeat
  background-position: center center
  height: 500px
  width: auto

h3
  font-size: 1em

.text-yellow
  color: $dutche-primary-yellow

.uppercase
  text-transform: uppercase

.justify
  text-align: justify

.story-intro
  color: $dutche-primary-yellow
  font-size: 1.25em
</style>
